import * as React from 'react';
const FilterDropdownMenuWrapper = (props) => (React.createElement("div", { className: props.className, onClick: e => e.stopPropagation() }, props.children));
export default FilterDropdownMenuWrapper;
